<div class="material-datatables">
  <table
    id="trakingdatatables"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%"
  >
    <thead>
      <tr>
        <th>{{ dataTable.headerRow[0] }}</th>
        <th class="text-center">{{ dataTable.headerRow[1] }}</th>
        <th class="text-center">{{ dataTable.headerRow[2] }}</th>
        <th class="text-center">{{ dataTable.headerRow[3] }}</th>
        <th class="text-center">{{ dataTable.headerRow[4] }}</th>
      </tr>
    </thead>

    <tbody>
      <tr
        id="itemweight{{ row[0] }}"
        *ngFor="let row of dataTable.dataRows; let i = index"
      >
        <td>{{ row[0] ? row[0] : "N/A" }}</td>
        <td class="text-center">{{ row[1] ? row[1] : "N/A" }}</td>
        <td class="text-center">{{ row[2] ? row[2] : "N/A" }}</td>
        <td class="text-center">{{ row[3] ? row[3] : "N/A" }}</td>
        <!-- <td class="text-center">{{row[3] | slice:0:15}}{{row[3].length > 15 ? '...' : ''}}</td> -->
        <td class="text-right">
          <a
            class="btn btn-link btn-info btn-just-icon"
            (click)="saveEmit('show', row[0], row)"
            ><i class="material-icons">mode_edit</i></a
          >
          <!-- <a class="btn btn-link btn-dark btn-just-icon" (click)="saveEmit('print',row[0], row)"><i class="material-icons">local_printshop</i></a> -->
          <a
            (click)="saveEmit('delete', row[0], row)"
            class="btn btn-link btn-danger btn-just-icon"
            ><i class="material-icons">close</i></a
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
